import { Stack } from '@mui/material';
import dayjs from 'dayjs';

import { Text } from '@telegram-apps/telegram-ui';
import { toDueString, toDueTime } from '../../helpers/datetime';
import { CommonIcon } from './CommonIcon';

export type DueTimeProps = {
    date: dayjs.Dayjs;
    dueDateVerbose?: boolean;
}

export const DueTime = ({ date, dueDateVerbose }: DueTimeProps) => {
    const dueStr = date && date.isValid()
        ? dueDateVerbose 
            ? toDueString(date) 
            : toDueTime(date)
        : '';

    return (
        dueStr
        ? (<Stack direction="row" alignItems="center" gap="3px">
            <CommonIcon type="filled" icon="calendar_month" size={13} color="var(--tgui--hint_color)" />
            <Text style={{ fontSize: '13px', color: "var(--tgui--hint_color)"}}>
                {dueStr}
            </Text>
          </Stack>)
        : null
    );
}